import * as React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "@reach/router";

const StyledContainer = styled(Container)`
  .btn:hover > a {
    color: #fff !important;
  }

  button {
    margin: 0 28px !important;
  }

  p {
    letter-spacing: 0.2px;
  }

  @media only screen and (max-width: 600px) {
    .link-mob {
      text-align: center !important;
    }
  }
`;

const LinkedinchromeExtension = () => {
  return (
    <StyledContainer>
      <div className="row pt-4">
        <div className="col-sm-6">
          <h2>Prospecting & Enrichment</h2>
          <i>LinkedIn Chrome Extension to capture high-profile leads</i>
          <ul className="text-left">
            <li className="py-3 fa fa-circle">
              Clearout's LinkedIn Chrome Extension enables you to quickly
              identify potential prospects and capture verified business email
              addresses within minutes.
            </li>
            <li className="fa fa-circle">
              In addition to email addresses, the extension allows you to
              enrich data for single or multiple prospects, finding valid
              contact numbers with ease.
            </li>
            <li className="pt-3 fa fa-circle">
              This feature streamlines your lead generation process and
              enhances efficiency, saving you time and enabling you to focus
              on converting leads into customers.
            </li>
          </ul>
          <div className="align-center">
            <Link to="/sales-prospecting" aria-label="Explore Prospecting" className="btn btn-outline-dark px-3">
              Explore <FaArrowRight />
            </Link>
          </div>
        </div>
        <div className="col-sm-6">
          <StaticImage
            src="../../images/clearout_prospecting_and_enrichment_update.png"
            alt="Clearout's LinkedIn Chrome Extension to identify and enrich potential prospects"
            placeholder="blurred"
            layout="fullWidth"
          />
        </div>
      </div>
    </StyledContainer>
  );
};

export default LinkedinchromeExtension;
